import { render, staticRenderFns } from "./imageText.vue?vue&type=template&id=2ce06f65"
import script from "./imageText.vue?vue&type=script&lang=js"
export * from "./imageText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports